import { cn } from '@/styles/utils';
import React from 'react';

interface VerticalDividerProps {
  className?: string;
}

const VerticalDivider: React.FC<VerticalDividerProps> = ({
  className = '',
}) => {
  return <div className={cn('w-0.25 h-4 bg-[#DEE2E7]', className)} />;
};

export default VerticalDivider;
